import PropTypes from 'prop-types'
import css from './confirmation.css'

/**
 * Edit Panel - Confirmation: You sure you wanna do whatever it is you're doing?
 *
 */
const Confirmation = ({
    className,
    prompt = 'Are you sure you want to delete this GIF?',
    yesCta = 'Delete',
    noCta = 'Cancel',
    onConfirmClick,
    onCancelClick,
    yesColor = '',
    noColor = '',
}) => {
    const panel = (
        <div>
            <div className={css.title}>{prompt}</div>
            <div className={css.buttons}>
                <div className={css.naw} style={{ backgroundColor: noColor }} onClick={onCancelClick}>
                    {noCta}
                </div>
                <div className={css.yeah} style={{ backgroundColor: yesColor }} onClick={onConfirmClick}>
                    {yesCta}
                </div>
            </div>
        </div>
    )
    return <div className={css.confirm}>{className ? <div className={className}>{panel}</div> : panel}</div>
}

Confirmation.propTypes = {
    className: PropTypes.string,
    prompt: PropTypes.string,
    yesCta: PropTypes.string,
    noCta: PropTypes.string,
    onConfirmClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
}

export default Confirmation
